import { TRule } from '../../typings';

export const TYROO_PRICELIST_RULESET: TRule[] = [
  {
    type: 'rule.map',
    sourceKey: 'c.EAN',
    destination: 'product',
    targetKey: 'ean',
  },
  {
    type: 'rule.map',
    sourceKey: "c['Tyroo-article-number']",
    destination: 'product',
    targetKey: 'supplierCode',
  },
  {
    type: 'rule.map',
    sourceKey: 'c.producer',
    destination: 'product',
    targetKey: 'brand',
  },
  {
    type: 'rule.map',
    sourceKey: 'c.price',
    destination: 'product',
    targetKey: 'priceEUR',
    outputType: 'number',
  },
];
